import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'
import { Subscriptions } from '@carsys/enums/subscription'

import { ModulePermissions } from './Modules'
import { NewPermissionSuite, PermissionRequirement } from '@cbgms/base/permissions/permissionsUtils'
import { ModifiedPermissionCollection } from 'app/auth/state/reducers/permissionExtension'

const getModulePermissions = (modules: Subscriptions[]): string[] => {
  return [...new Set((modules || []).map(m => ModulePermissions[m] || []).flat())]
}

export const filterPermissionsByModifiers = (permissionModifiers: ModifiedPermissionCollection, permissions: string[]) => {
  return permissions
    .reduce<string[]>((output, current) => {
      return [...output, !permissionModifiers[current]?.Deactivated ? current : '']
    }, [])
    .filter(a => !!a)
}

const useUserPermissionProviderByModules = () => {
  const shopModules = useSelector<IRootReducerState, Subscriptions[]>(state => state.auth.shop.Modules) || []
  const permissions = useMemo(() => getModulePermissions(shopModules), [shopModules])
  const permissionModifiers =
    useSelector<IRootReducerState, ModifiedPermissionCollection>(state => state.auth?.permissionExtension?.modifiedPermissions) || {}

  const filteredPermissions = useMemo(
    () => filterPermissionsByModifiers(permissionModifiers, permissions),
    [permissionModifiers, permissions]
  )
  return filteredPermissions
}

const suite = NewPermissionSuite(useUserPermissionProviderByModules)
export const RequiredPermission = suite.RequiredPermission
export const usePermissionsChecker = suite.usePermissionsChecker
export const useHasPermission = suite.useHasPermission
export const hasPermission = (modules: Subscriptions[], requirement: PermissionRequirement, modifiers: ModifiedPermissionCollection) => {
  const allPermissions = getModulePermissions(modules)
  const filteredPermissions = filterPermissionsByModifiers(modifiers, allPermissions)
  return suite.hasPermission(filteredPermissions, requirement)
}
